import React from 'react';
import {PersonBrowseCommon} from './PersonBrowseCommon';
import {PAGE_TITLE_BASE} from './../../constants.js';
import { Header, Segment, Grid, Message } from 'semantic-ui-react'

export function PersonBrowse(props) {
	document.title = 'People | ' + PAGE_TITLE_BASE;

	return (
		<div>
			<Segment inverted>
				<Header inverted as='h1' style={{textAlign:'center'}}>
					Browse People
				</Header>
			</Segment>
			<Grid>
				<Grid.Row>
					<Message warning style={{textAlign:'center'}}>
						<Message.Header><br/>This feature is a Beta and is not fully accurate</Message.Header>
					</Message>
				</Grid.Row>
			</Grid>
			<PersonBrowseCommon urlParams={true}/>
		</div>
	);
}